import { useDestinationContext } from '@/src/contexts'

import DestinationQuickFacts from './destinationQuickFacts'

const DestinationQuickFactsWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const qf = sections.quickFacts
    if (!qf) return null

    const facts = [
        { label: 'Airport', value: `${qf.airportName} (${qf.airportCode})` },
        { label: 'Country', value: qf.country },
        { label: 'Currency', value: qf.currency },
        { label: 'Language', value: qf.language },
        { label: 'Flight demand', value: qf.averageFlightDemand },
    ].filter(f => f.value)

    return <DestinationQuickFacts facts={facts} />
}

export default DestinationQuickFactsWrapper
